// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type FuhrparkeintragPage } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheFuhrparkeintraegeQuery = {
  search?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSucheFuhrparkeintraege(): (
  taetigkeitsberichtId: string,
  query: SucheFuhrparkeintraegeQuery
) => Promise<FuhrparkeintragPage> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId, query = {}) =>
      (await getAPI()).fuhrparkeintraege.sucheFuhrparkeintraege({
        taetigkeitsberichtId,
        ...query,
      }),
    [getAPI]
  );
}
